<div class="flex h-full flex-col gap-4 bg-background-modal px-6 py-4">
  <div class="flex min-h-0 flex-grow flex-col">
    <!-- Tabs -->
    <div class="flex w-full flex-col justify-between px-8">
      <div class="flex w-full justify-between gap-8">
        @if (!isOpenDental()) {
          <div
            class="flex-grow cursor-pointer px-1 pb-3 pt-1 text-center text-h4 font-light text-text-tertiary"
            (click)="selectTab(ReasonSelectorModalTabs.InitialReason)"
            [class.selected]="activeTab === ReasonSelectorModalTabs.InitialReason"
          >
            {{ 'reason_selector_initial_reason' | translate }}
          </div>
        }
        <div
          class="flex-grow cursor-pointer px-1 pb-3 pt-1 text-center text-h4 font-light text-text-tertiary"
          (click)="selectTab(ReasonSelectorModalTabs.TreatmentPlan)"
          [class.selected]="activeTab === ReasonSelectorModalTabs.TreatmentPlan"
        >
          {{ 'reason_selector_treatment_plan' | translate }}
        </div>
        <div
          class="flex-grow cursor-pointer px-1 pb-3 pt-1 text-center text-h4 font-light text-text-tertiary"
          (click)="selectTab(ReasonSelectorModalTabs.OtherCodes)"
          [class.selected]="activeTab === ReasonSelectorModalTabs.OtherCodes"
        >
          {{ 'onboarding_tabs_other_codes' | translate }}
        </div>
      </div>
    </div>
    <div class="mt-4 flex min-h-0 flex-grow flex-col">
      @if (activeTab === ReasonSelectorModalTabs.InitialReason) {
        <lib-initial-reason
          [isLoading]="viewModel().initialReasons.state === DataState.Loading"
          [initialReasons]="viewModel().initialReasons.data ?? []"
          [selectedReasons]="viewModel().selectedReasons"
          (itemSelected)="addReason($event)"
          (itemDeselected)="removeReason($event)"
          class="h-full"
        ></lib-initial-reason>
      }
      @if (activeTab === ReasonSelectorModalTabs.TreatmentPlan) {
        <lib-treatment-plan-selector class="flex min-h-0 flex-grow flex-col"></lib-treatment-plan-selector>
      }
      @if (activeTab === ReasonSelectorModalTabs.OtherCodes) {
        <lib-other-codes class="flex min-h-0 flex-grow flex-col"></lib-other-codes>
      }
    </div>
  </div>

  @if (selectedReasons().length) {
    <lib-reason-selector-modal-footer
      [selectedReasons]="selectedReasons()"
      (itemDeselected)="removeReason($event)"
    ></lib-reason-selector-modal-footer>
  }

  <div class="flex justify-between">
    <div class="flex items-center">
      <svg-icon key="px-24-tick" class="text-secondary-green"></svg-icon>
      <span class="typo-h5-light text-text-tertiary"
        >{{ selectedReasons().length }} {{ 'reason_selector_selected' | translate | lowercase }}</span
      >
    </div>
    <div class="flex gap-10">
      <button type="button" class="btn-text" (click)="closeDialog()">{{ 'schedule_add_time_pattern_modal_cancel' | translate }}</button>
      <button type="button" class="btn-primary" (click)="addReasons()">
        {{ 'schedule_reason_selector_add' | translate }}
      </button>
    </div>
  </div>
</div>
